import React from "react";
import { useTranslation } from "react-i18next";
import SwiperCore, { Autoplay, Pagination } from "swiper/core";
import { Swiper, SwiperSlide } from "swiper/react";
import useSWR from "swr";
import { useWithLang } from "../i18n";
import { ApiResponse, getBaseURL } from "../utils/api";
import { SettingProp } from "../utils/types";

SwiperCore.use([Pagination, Autoplay]);

interface Slider {
  image: string;
  link: string;
}

const WhatsAbout = () => {
  const { t } = useTranslation();
  const { f } = useWithLang();
  const { data: about } = useSWR<ApiResponse<SettingProp>>(
    f("/public/pages/about"),
    {
      initialData: null,
    }
  );

  const { data: sliders } = useSWR<ApiResponse<Slider[]>>(
    f("/public/programs"),
    {
      initialData: {
        success: true,
        data: [
          { image: "", link: "" },
          { image: "", link: "" },
          { image: "", link: "" },
        ],
      },
    }
  );

  return (
    <>
      <div className="flex flex-col md:flex-row">
        <div className="md:w-6/12 md:pr-4 mb-8 md:mb-0">
          <div className="flex items-center">
            {/* <div className="mr-3">
            <img
              src="/images/pandi.png"
              className="w-14 md:w-auto"
              alt="pandi id logo"
            />
          </div> */}
            <h2 className="text-3xl font-semibold font-sans">
              {t("About Pandi Meeting")}
            </h2>
          </div>
          <div className="content mt-3 font-sans text-lg text-justify">
            {about === null ? (
              <>
                {[...new Array(2)].map((_, index) => (
                  <div className="mb-8" key={index}>
                    <div className="bg-gray-300 mb-4 animate-pulse h-4 rounded-md w-11/12" />
                    <div className="bg-gray-300 mb-4 animate-pulse h-4 rounded-md w-10/12" />
                    <div className="bg-gray-300 mb-4 animate-pulse h-4 rounded-md w-11/12" />
                    <div className="bg-gray-300 mb-4 animate-pulse h-4 rounded-md w-9/12" />
                  </div>
                ))}
              </>
            ) : (
              <div>
                {about?.data?.value?.split("\n").map((content, index) => (
                  <p className="mb-3" key={index}>
                    {content}
                  </p>
                ))}
              </div>
            )}
          </div>
        </div>
        <div className="md:w-6/12 md:pl-4 md:mt-8 mb-10">
          <div className="-mx-2">
            <Swiper
              speed={1000}
              autoplay={{
                delay: 2000,
              }}
              slidesPerView={1}
              pagination={{
                clickable: true,
                bulletClass:
                  "block bg-transparent w-3 h-3 rounded-full border border-gray-600 cursor-pointer ml-1",
                bulletActiveClass: "bg-gray-600",
                el: ".top-slide-paginate",
              }}>
              {sliders.data.map((item, index) => (
                <SwiperSlide key={index} className="px-2">
                  <a href={item.link || "/"} target="_blank" rel="noreferrer">
                    <div
                      className="bg-gray-200 border border-gray-400 rounded-lg bg-center bg-contain bg-no-repeat"
                      style={{
                        paddingBottom: "75.5%",
                        backgroundImage: `url("${getBaseURL(item.image)}")`,
                      }}
                    />
                  </a>
                </SwiperSlide>
              ))}
            </Swiper>
          </div>
          <div className="top-slide-paginate flex items-center justify-end -ml-2 mt-4"></div>
        </div>
      </div>
     
    </>
  );
};

export default WhatsAbout;
